module.exports = __webpack_public_path__ + "img/icon-google.aa6420b8.svg";